import { pruneSearch } from "@/lib/router-search";

/**
 * Search params carried by a Slack channel notice (or an agent-thread
 * suggestion). They prefill the canonical Automation event editor; all fields
 * are optional for ordinary creation.
 */
export type PrefilledChannel = {
	listen?: string;
	platform?: string;
	team?: string;
	label?: string;
	connection?: string;
	resource_type?: string;
	resource?: string;
	events?: string;
	/** Agent to prefill as the automation's executor (agent-thread CTA). */
	agent?: string;
};

export function parsePrefilledChannel(
	search: Record<string, unknown>,
): PrefilledChannel {
	const str = (key: keyof PrefilledChannel) =>
		typeof search[key] === "string" ? (search[key] as string) : undefined;
	// `pruneSearch` strips undefined keys — without it TSR's URL stringifier and
	// validateSearch disagree on shape, causing a commit loop on mount.
	return pruneSearch({
		listen: str("listen"),
		platform: str("platform"),
		team: str("team"),
		label: str("label"),
		connection: str("connection"),
		resource_type: str("resource_type"),
		resource: str("resource"),
		events: str("events"),
		agent: str("agent"),
	}) as PrefilledChannel;
}
